var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 41.861 41.861"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19460"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h41.861v41.861H0z",
  "data-name": "Rectangle 7618"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M32.521 16.193a5.1 5.1 0 0 0-.943-2.352 3.38 3.38 0 0 0-2.371-1c-3.309-.241-8.276-.241-8.276-.241h-.009s-4.968 0-8.276.241a3.38 3.38 0 0 0-2.371 1 5.1 5.1 0 0 0-.938 2.352 36 36 0 0 0-.24 3.837v1.8a36 36 0 0 0 .236 3.838 5.14 5.14 0 0 0 .938 2.352 4.03 4.03 0 0 0 2.611 1.01c1.895.181 8.045.236 8.045.236s4.972-.009 8.281-.245a3.39 3.39 0 0 0 2.371-1 5.1 5.1 0 0 0 .943-2.352 36 36 0 0 0 .236-3.838v-1.8a36 36 0 0 0-.237-3.838m-14.039 7.814v-6.662l6.391 3.342Z",
  "data-name": "Path 27376"
}))));
export { SvgYoutube as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube.203d45475e85207e4c9233dc920ae32d.svg";